class Countries {
  wrapper = null;

  constructor(el) {
    this.wrapper = $(el);

    if (this.wrapper.length) {
      this.hoverState();
      this.disposeCardContent();
    }
  };

  hoverState() {

    $(".countries__card").mouseenter(function () {
      $('.countries__card').not(this).addClass('hovered');
    });

    $(".countries__card").mouseleave(function () {
      $('.countries__card').removeClass('hovered');
    });
  }

  disposeCardContent() {
    const dataBlocks = $(".countries__card");

    $(document).ready(function () {
      dataBlocks.each(function () {

        const blockHeight = $(this).find(".countries__data-block").height();
        const difference = 718 - blockHeight;
        const titleHeight = $(this).find(".data__title").height();

        const height = blockHeight - titleHeight;

        const block = $(this).find(".countries__data-block");

        if (!height) {
          return;
        }

        block.css('transform', 'translateY(' + height + 'px)');
        //console.log(block);
      });
    });
  };

}

export default Countries;
